var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      {
        staticStyle: { "padding-top": "80px" },
        attrs: { id: "navigationPlaceholder" },
      },
      [_c("AdminNavigationV2", { attrs: { tid: _setup.tid } })],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-7" }, [
          _c(
            "h1",
            {
              staticStyle: {
                "font-size": "2em",
                "font-weight": "300",
                color: "#33475b",
              },
            },
            [_vm._v("Pipeline data preview")]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "btn btn-link btn-sm",
              attrs: {
                href: `/#/admin/integrations/pipelines/details/${_setup.tid}/${_setup.id}`,
                type: "button",
              },
            },
            [
              _c("i", {
                staticClass: "fa fa-arrow-left",
                attrs: { "aria-hidden": "true" },
              }),
              _vm._v(" "),
              _c("span", [_vm._v("Back")]),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-lg-5 col-sm-6 text-right" }),
      ]),
    ]),
    _vm._v(" "),
    _c("hr", {
      staticStyle: { "border-color": "#bbb", margin: "20px 0 30px" },
    }),
    _vm._v(" "),
    _c("div", { staticClass: "container-fluid" }, [
      _setup.preview
        ? _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col" }, [
              _c("h5", [
                _vm._v(
                  _vm._s(_setup.preview.SourceTitle) +
                    " (" +
                    _vm._s(_setup.preview.SourceData?.length) +
                    ")"
                ),
              ]),
              _vm._v(" "),
              _setup.preview.MissingSourceId
                ? _c(
                    "div",
                    {
                      staticClass: "alert alert-danger",
                      attrs: { role: "alert" },
                    },
                    [
                      _vm._v(
                        "\n                    Missing ID column: " +
                          _vm._s(_setup.preview.SourceId) +
                          "\n                "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _setup.preview.SourceData.length
                ? _c("table", { staticClass: "table table-dark" }, [
                    _c("thead", [
                      _c(
                        "tr",
                        [
                          _c("th", [_vm._v("#")]),
                          _vm._v(" "),
                          _vm._l(_setup.preview.SourceHeaders, function (h) {
                            return _c("th", [
                              _c(
                                "span",
                                {
                                  class: {
                                    "fg-color-orange":
                                      _setup.preview.SourceId.includes(h),
                                  },
                                },
                                [_vm._v(_vm._s(h))]
                              ),
                            ])
                          }),
                        ],
                        2
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_setup.preview.SourceData, function (row, i) {
                        return _c(
                          "tr",
                          [
                            _c("td", [_vm._v(_vm._s(i + 1))]),
                            _vm._v(" "),
                            _vm._l(row, function (cell) {
                              return _c("td", [_vm._v(_vm._s(cell))])
                            }),
                          ],
                          2
                        )
                      }),
                      0
                    ),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col" }, [
              _c("h5", [
                _vm._v(
                  _vm._s(_setup.preview.DestTitle) +
                    " (" +
                    _vm._s(_setup.preview.DestData?.length) +
                    ")"
                ),
              ]),
              _vm._v(" "),
              _setup.preview.MissingDestId
                ? _c(
                    "div",
                    {
                      staticClass: "alert alert-danger",
                      attrs: { role: "alert" },
                    },
                    [
                      _vm._v(
                        "\n                    Missing ID column: " +
                          _vm._s(_setup.preview.DestId) +
                          "\n                "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _setup.preview.DestData.length
                ? _c("table", { staticClass: "table" }, [
                    _c("thead", [
                      _c(
                        "tr",
                        [
                          _c("th", [_vm._v("#")]),
                          _vm._v(" "),
                          _vm._l(_setup.preview.DestHeaders, function (h) {
                            return _c("th", [
                              _c(
                                "span",
                                {
                                  class: {
                                    "fg-color-orange":
                                      _setup.preview.DestId.includes(h),
                                  },
                                },
                                [_vm._v(_vm._s(h))]
                              ),
                            ])
                          }),
                        ],
                        2
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_setup.preview.DestData, function (row, i) {
                        return _c(
                          "tr",
                          [
                            _c("td", [_vm._v(_vm._s(i + 1))]),
                            _vm._v(" "),
                            _vm._l(row, function (cell) {
                              return _c("td", [
                                _c("div", { staticClass: "text-ellipsis" }, [
                                  _vm._v(_vm._s(cell)),
                                ]),
                              ])
                            }),
                          ],
                          2
                        )
                      }),
                      0
                    ),
                  ])
                : _vm._e(),
            ]),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }